<template>
  <div class="page">
    <div class="row">
      <div class="sm-12">
        <div class="box-page">
          <div class="row">
            <div class="sm-12">
              <div class="title">
                <i class="mdi mdi-calculator"></i>
                <h2>Demonstrativo Financeiro</h2>
              </div>
            </div>
          </div>
          <form @submit.prevent.stop="loadDemonstrativo">
            <div class="row">
              <div class="sm-6 md-4">
                <label>
                  De:
                  <input
                    v-model="data_de"
                    type="date"
                    lang="pt"
                    placeholder="De" />
                </label>
              </div>
              <div class="sm-6 md-4">
                <label>
                  Até:
                  <input
                    v-model="data_ate"
                    type="date"
                    lang="pt"
                    placeholder="Até" />
                </label>
              </div>
              <div class="sm-12 md-4">
                <button
                  class="button secondary full"
                  style="margin-top: 28px"
                  v-if="gerando"
                  disabled>
                  Gerando...
                </button>
                <button
                  type="submit"
                  class="button secondary full"
                  style="margin-top: 28px"
                  v-else>
                  Gerar extrato
                </button>
              </div>
            </div>
          </form>

          <div class="row">
            <div class="sm-12">
              <hr />
            </div>
            <div class="sm-12 md-4">
              <p class="text-primary-darker-1">
                <strong>Condomínio:</strong>
                {{ condominio.nome }}
              </p>
            </div>
            <div class="sm-12 md-4">
              <!--
                    <p class="text-primary-darker-1">
                        <strong>CNPJ:</strong>
                        {{ cliente.cpf | formatCPF }}
                    </p>
                -->
            </div>
            <div class="sm-12 md-4">
              <p class="text-primary-darker-1">
                <strong>Abreviação:</strong>
                {{ condominio.abrev }}
              </p>
            </div>
            <div class="sm-12">
              <p class="text-primary-darker-1">
                <strong>Endereço:</strong>
                {{ condominio.endereco.enderecoCompleto }}
              </p>
              <hr />
            </div>
          </div>
          <div
            class="row"
            v-if="receitas != null || despesas != null || sintese != null">
            <div class="sm-12">
              <div class="flex justify-between align-center">
                <p class="text-primary-darker-1">
                  <strong
                    >Demonstrativo Financeiro de
                    {{ data_de | date("dd/LL/yyyy") }} à
                    {{ data_ate | date("dd/LL/yyyy") }}</strong
                  >
                </p>
                <div class="flex justify-end align-center">
                  <button
                    class="button secondary visible-md"
                    style="margin-right: 10px; white-space: nowrap"
                    @click="exportToExcel">
                    Exportar para Excel
                  </button>
                  <button
                    class="button secondary print-button visible-md"
                    @click="print">
                    Imprimir
                  </button>
                </div>
              </div>
              <hr />
            </div>
          </div>
          <div v-if="!gerando">
            <Receitas :receitas="receitas" v-if="receitas != null"></Receitas>
            <Despesas :despesas="despesas" v-if="despesas != null"></Despesas>
            <Sintese :sintese="sintese" v-if="sintese != null"></Sintese>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import ExcelJS from 'exceljs';
import { DateTime } from "luxon";
import api from "/plugins/api";
import Swal from "sweetalert2";
import formatCPF from "/plugins/format-cpf";

import Receitas from "./demonstrativo-financeiro/receitas.vue";
import Despesas from "./demonstrativo-financeiro/despesas.vue";
import Sintese from "./demonstrativo-financeiro/sintese.vue";

export default {
  components: {
    Receitas,
    Despesas,
    Sintese,
  },
  filters: {
    formatCPF(value) {
      return formatCPF(value);
    },
    date(value, format) {
      return DateTime.fromSQL(value).toFormat(format);
    },
  },
  data() {
    let days = DateTime.local().daysInMonth;
    return {
      gerando: false,
      errors: [],
      receitas: null,
      despesas: null,
      sintese: null,
      data_de: DateTime.local().toFormat("yyyy-LL-01"),
      data_ate: DateTime.local().toFormat(`yyyy-LL-${days}`),
    };
  },
  computed: {
    cliente() {
      return this.$store.state.cliente;
    },
    condominio() {
      return this.$store.getters.condominio;
    },
    codigo_condominio() {
      if (!this.condominio) {
        return this.condominio.codigo;
      }
      return this.condominio.codigo;
    },
  },
  methods: {
    async exportToExcel() {
      try {
        const Workbook = await import("exceljs").then(e => e.Workbook);
        const workbook = new Workbook();

        // Add worksheet for RECEITAS
        const worksheetReceitas = workbook.addWorksheet("RECEITAS");
        const receitasHeaderRow = worksheetReceitas.addRow([
          "Descrição",
          "Valor(R$)",
        ]);
        receitasHeaderRow.font = { bold: true };
        this.receitas.Itens.forEach(receita => {
          const row = worksheetReceitas.addRow([
            receita.Descricao,
            receita.Valor,
          ]);
          const cell = row.getCell(2);
          if (receita.Valor < 0) {
            cell.font = {
              color: { argb: "FF0000" }, // Red color for negative values
            };
          }
        });
        const totalReceitasRow = worksheetReceitas.addRow([
          "Total Receitas",
          this.receitas.ValorReceitas,
        ]);
        totalReceitasRow.font = { bold: true };
        const totalReceitasCell = totalReceitasRow.getCell(2);
        if (this.receitas.ValorReceitas < 0) {
          totalReceitasCell.font = { color: { argb: "FF0000" } }; // Red color for negative total
        }

        // Add worksheet for DESPESAS
        const worksheetDespesas = workbook.addWorksheet("DESPESAS");
        this.despesas.Grupos.forEach(grupo => {
          // Add group description row
          const groupDescriptionRow = worksheetDespesas.addRow([
            grupo.Descricao,
          ]);
          const groupDescriptionCell = groupDescriptionRow.getCell(1);
          groupDescriptionCell.font = { bold: true }; // Make the group description bold

          // Add header row
          const headerRow = worksheetDespesas.addRow([
            "Descrição",
            "Valor(R$)",
          ]);
          headerRow.font = { bold: true }; // Make the header bold

          // Add expense items
          grupo.Itens.forEach(despesa => {
            const formattedValue = despesa.Valor * -1;
            const row = worksheetDespesas.addRow([
              despesa.Descricao,
              formattedValue,
            ]);
            const cell = row.getCell(2);
            if (formattedValue < 0) {
              cell.font = { color: { argb: "FF0000" } }; // Red color for negative values
            }
          });

          // Add total row
          const totalRow = worksheetDespesas.addRow([
            "Total",
            -grupo.ValorGrupo,
          ]);
          totalRow.font = { bold: true };
          const totalCell = totalRow.getCell(2);
          totalCell.font = { bold: true, color: { argb: "FF0000" } }; // Make the total bold and red for negative values
          worksheetDespesas.addRow([]);
        });

        // Add worksheet for SÍNTESE
        const worksheetSintese = workbook.addWorksheet("SÍNTESE");
        const sinteseHeaderRow = worksheetSintese.addRow([
          "Descrição",
          "Valor(R$)",
        ]);
        sinteseHeaderRow.font = { bold: true };
        const sinteseData = [
          ["Saldo Anterior", this.sintese.Totalizacao.ValorSaldoAnterior],
          ["Receitas", this.sintese.Totalizacao.ValorReceitas],
          ["Despesas", this.sintese.Totalizacao.ValorDespesas],
          ["Saldo Atual", this.sintese.Totalizacao.ValorSaldoFinal],
        ];
        sinteseData.forEach(item => {
          const row = worksheetSintese.addRow(item);
          const cell = row.getCell(2);
          if (item[1] < 0) {
            cell.font = {
              color: { argb: "FF0000" }, // Red color for negative values
            };
          }
        });

        const saldoAtualRow = worksheetSintese.lastRow;
        saldoAtualRow.font = { bold: true };
        const saldoAtualCell = saldoAtualRow.getCell(2);
        if (this.sintese.Totalizacao.ValorSaldoFinal < 0) {
          saldoAtualCell.font = { color: { argb: "FF0000" } }; // Red color for negative total
        }

        if (
          this.sintese &&
          this.sintese.Subcontas &&
          this.sintese.Subcontas.length > 0
        ) {
          worksheetSintese.addRow([]);
          const subcontasHeaderRow = worksheetSintese.addRow([
            "Subconta Descrição",
            "Subconta Valor(R$)",
          ]);
          subcontasHeaderRow.font = { bold: true };
          this.sintese.Subcontas.forEach(subconta => {
            const row = worksheetSintese.addRow([
              subconta.Descricao,
              subconta.Valor,
            ]);
            const cell = row.getCell(2);
            if (subconta.Valor < 0) {
              cell.font = {
                color: { argb: "FF0000" }, // Red color for negative values
              };
            }
          });
        }

        // Finalize the workbook and download the file
        const formattedDateDe = DateTime.fromISO(this.data_de).toFormat(
          "dd-LL-yyyy"
        );
        const formattedDateAte = DateTime.fromISO(this.data_ate).toFormat(
          "dd-LL-yyyy"
        );

        // Generating the filename
        const currentDate = DateTime.local().toFormat("yyyyLLdd");
        const filename = `Demonstrativo_Financeiro_${formattedDateDe}_${formattedDateAte}_${this.condominio.abrev}_${this.condominio.nome}_${currentDate}.xlsx`;

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();

        // Clean up after download
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error exporting to Excel:", error);
      }
    },
    print() {
      window.print();
    },
    async loadDemonstrativo() {
      try {
        if (this.gerando) {
          return;
        }
        if (!this.codigo_condominio) {
          return;
        }

        if ("" == this.data_de) {
          throw new Error("Informe a data de início.");
        }

        if ("" == this.data_ate) {
          throw new Error("Informe a data de término.");
        }

        this.receitas = null;
        this.despesas = null;
        this.sintese = null;

        this.gerando = true;

        let {
          data: { Receitas, Despesas, Sintese },
        } = await api.get(
          `condominios/${this.codigo_condominio}/demonstrativo-financeiro/${this.data_de}/${this.data_ate}`
        );

        this.receitas = Receitas;
        this.despesas = Despesas;
        this.sintese = Sintese;
      } catch (err) {
        this.errors = [];
        let text = err.message || "Não foi possível carregar o demonstrativo.";

        if (err.response && err.response.data) {
          text = err.response.data.error;
        }
        Swal.fire({
          icon: "error",
          title: "Oops",
          text,
        });
        console.error(err);
        this.errors = [...this.errors, err];
      }
      this.gerando = false;
    },
  },
  created() {
    this.loadDemonstrativo();
  }
};
</script>
<style lang="less" scoped>
form {
  button {
    margin-top: 1.25em;
  }
}

.sintese {
  table {
    tbody {
      tr {
        td {
          border: none;
        }
      }
    }
  }
}
</style>
